import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {Preferences} from '@/app/interfaces/preferences';

export const fetchPreferencesAction = createAsyncThunk<
	{fieldSetOnly: 'overall' | 'personalized'} | void,
	Partial<Preferences>,
	void
>('config/fetchPreferences', async (params, {context, success}) => {
	const {fieldSetOnly} = params || {};
	const preferences = await context.backendAPI.config.getPreferences(fieldSetOnly);
	return success(preferences);
});
